import { createBrowserHistory } from "history";

const xHistory = createBrowserHistory();
export default xHistory;
